module.exports = __webpack_public_path__ + "img/packetgrup-product-page.f63fb216.webp";